


import api from '../api/calculator';
import apiDrain from '../api/calculatorDrain';
import apiPavement from '../api/calculatorPavement';


export default {


    getProducts({commit, state}){
        if(state.mode === 'default') {
            api.getProducts((products => {
                commit('setProducts', products);
            }), state.selectedCriteria);
        }else if(state.mode === 'drain'){
            apiDrain.getProducts((products => {
                commit('setProducts', products);
            }), state.selectedCriteria)
        }else{
            apiPavement.getProducts((products => {
                commit('setProducts', products);
            }), state.selectedCriteria)
        }

    },
    getSteps({commit, state}){
        if(state.mode === 'default') {
            api.getSteps((steps => {
                commit('setSteps', steps)
            }))
        }else if(state.mode === 'drain'){
            apiDrain.getSteps((steps => {
                commit('setSteps', steps)
            }))
        }else{
            apiPavement.getSteps((steps => {
                commit('setSteps', steps)
            }))
        }

    },

    getCriteria({commit, state}){
        if(state.mode === 'default') {
            api.getCriteria((criteria) => {
               commit('setCriteria', criteria)
            })
        }else if(state.mode === 'drain'){
            apiDrain.getCriteria((criteria) => {
                commit('setCriteria', criteria)
            })
        }else{
            apiPavement.getCriteria((criteria) => {
                commit('setCriteria', criteria)
            })
        }
    }
}